import { useQuery } from '@tanstack/react-query';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@noissue/os-ui';
import { meQueryOptions } from './shell';

export function Home() {
  const { data: me } = useQuery(meQueryOptions);
  return (
    <div className="p-6">
      <Card className="max-w-xl">
        <CardHeader>
          <CardTitle>Welcome{me ? `, ${me.user.name.split(' ')[0]}` : ''}</CardTitle>
          <CardDescription>
            Choose a module from the sidebar. You see only the modules you have access to.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <p className="text-sm text-muted-foreground">
            {me?.visibleModuleIds.length
              ? `You have access to: ${me.visibleModuleIds.join(', ')}.`
              : 'You have no module access yet — ask a platform admin.'}
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
